import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=2b75669b&scoped=true"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"
import style0 from "./Select.vue?vue&type=style&index=0&id=2b75669b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b75669b",
  null
  
)

export default component.exports